import script from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=0244c341&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0244c341"]])

export default __exports__